<template>
    <button
        type="button"
        class="border border-transparent hover:border-red-500 text-red-500 hover:text-red-600 hover:bg-red-100 uppercase font-semibold tracking-wider leading-normal cursor-pointer"
        :class="size == 'small' ? 'text-2xs px-5 py-2' : 'text-xs px-6 py-3'"
        @click="$emit('click')"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        size: { default: 'normal'},
    },
}
</script>
